import React from 'react'
import styled from 'styled-components'
import colors from 'theme/colors'
import breakpoints from 'theme/breakpoints'
import { Bookmark } from 'lucide-react'

export default function Header({ title, subtitle }) {
    return (
        <Banner>
            <BannerInner>
                <BannerContent>
                    <IconBadge>
                        <Bookmark size={22} color={colors.neutralLight} />
                    </IconBadge>
                    <TextGroup>
                        <Title>{title}</Title>
                        {subtitle && <Subtitle>{subtitle}</Subtitle>}
                    </TextGroup>
                </BannerContent>

                <Decoration>
                    <Circle size={120} top={-30} right={-20} />
                    <Circle size={70} top={40} right={60} />
                    <Circle size={40} top={-10} right={140} />
                </Decoration>
            </BannerInner>
        </Banner>
    )
}

const Banner = styled.div`
    width: 100%;
    background: linear-gradient(135deg, ${colors.occasionalPurple} 0%, #7B2FBF 50%, ${colors.secondaryPurple} 100%);
    border-radius: 16px;
    overflow: hidden;
    position: relative;
`;

const BannerInner = styled.div`
    position: relative;
    padding: 28px 24px;

    @media screen and (min-width: ${breakpoints.md}) {
        padding: 36px 32px;
    }
`;

const BannerContent = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    position: relative;
    z-index: 2;
`;

const IconBadge = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.18);
    backdrop-filter: blur(4px);
    flex-shrink: 0;
`;

const TextGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

const Title = styled.h1`
    font-size: 24px;
    font-weight: 800;
    color: ${colors.neutralLight};
    margin: 0;
    letter-spacing: -0.02em;

    @media screen and (min-width: ${breakpoints.md}) {
        font-size: 28px;
    }
`;

const Subtitle = styled.p`
    font-size: 14px;
    color: rgba(255, 255, 255, 0.75);
    margin: 0;
    line-height: 1.4;
`;

const Decoration = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 50%;
    pointer-events: none;
    z-index: 1;
`;

const Circle = styled.div`
    position: absolute;
    width: ${({ size }) => size}px;
    height: ${({ size }) => size}px;
    top: ${({ top }) => top}px;
    right: ${({ right }) => right}px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.07);
`;
